import { createVanIconComponent } from "./van"

const Bars = createVanIconComponent("bars")
export default Bars
